<template>
    <modal
        name="cancel-order-modal"
        :adaptive="true"
        height="auto"
        width="600px"
        @before-open="beforeOpen"
    >
        <div
            class="w-full transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl transition-all sm:p-6"
        >
            <div class="sm:flex sm:items-start">
                <div
                    class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                >
                    <svg
                        class="h-6 w-6 text-red-600"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        ></path>
                    </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3
                        class="font-heading text-lg font-medium leading-6 text-gray-900"
                    >
                        Cancel Order
                    </h3>
                    <div class="mt-2">
                        <p class="text-sm leading-5 text-gray-500">
                            Are you sure you want to cancel this order? This
                            action cannot be undone.
                        </p>
                    </div>
                    <base-checkbox
                        v-if="isPreOrder"
                        v-model="cancelPrintJobs"
                        id="cancelPrintJobs"
                        label="Cancel order print jobs"
                        class="mt-4"
                    />
                </div>
            </div>
            <div class="mt-5 justify-end sm:mt-4 sm:flex sm:pl-4">
                <span class="flex w-full rounded-md shadow-sm sm:w-auto">
                    <button
                        @click="hideModal"
                        type="button"
                        class="focus:outline-none inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium leading-6 text-gray-700 shadow-sm transition duration-150 ease-in-out hover:text-gray-500 focus:border-blue-300 focus:shadow-outline sm:text-sm sm:leading-5"
                    >
                        Close
                    </button>
                </span>
                <span
                    class="flex w-full rounded-md shadow-sm sm:ml-3 sm:mt-0 sm:w-auto"
                >
                    <button
                        @click="cancelOrder"
                        type="button"
                        class="focus:outline-none inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium leading-6 text-white shadow-sm transition duration-150 ease-in-out hover:bg-indigo-500 focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
                    >
                        Cancel Order
                    </button>
                </span>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'CancelOrderModal',
    data() {
        return {
            order: null,
            isLoading: false,
            isPreOrder: false,
            cancelPrintJobs: false
        };
    },

    methods: {
        beforeOpen(event) {
            this.order = event.params.order;
            this.isPreOrder = event.params.order.isPreOrder;
        },
        hideModal() {
            this.$modal.hide('cancel-order-modal');
        },
        async cancelOrder() {
            this.isLoading = true;

            try {
                await this.$axios.put(`/orders/${this.order.id}/cancel`, {
                    cancelPrintJobs: this.cancelPrintJobs
                });
                this.hideModal();

                if (this.order.paymentType === 'Adyen') {
                    setTimeout(() => {
                        this.$emit('show-refund-modal', this.order, true);
                    }, 300);
                } else {
                    this.$emit('order-cancelled');
                }
            } catch (e) {
                this.hideModal();
                throw new Error(`API ${e}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
